export default __webpack_public_path__ + "static/media/overseas_en.ab12686d.csv";